import React, { FC } from 'react'

import DiskIcon from '../../../assets/icons/signup/pro-disk.svg'
import { useCommonModals } from '../../../context/CommonModalsContext'
import { useCurrentUser } from '../../../context/CurrentUserContext'
import { useGlobalToolConfig } from '../../../context/GlobalToolConfigContext'
import { useInternationalization } from '../../../context/InternationalizationContext'
import { trackPixelEvent } from '../../../utils/pixelUtils'
import {
  checkIfUserSubscriptionCanBeUpgraded,
  checkIfUserSubscriptionIsFree,
  checkIfUserSubscriptionIsMaximum,
} from '../../../utils/pricing'
import styles from './SidebarLayoutComponents.module.scss'

type Props = {
  showAlways?: boolean
}

const TryProButton: FC<Props> = ({ showAlways }) => {
  const { getText } = useInternationalization()
  const { currentUser } = useCurrentUser()
  const modalsConfig = useCommonModals()
  const { setSidebarOpen } = useGlobalToolConfig()

  const subscriptionIsFree = checkIfUserSubscriptionIsFree(currentUser)
  const subscriptionCanBeUpgraded = checkIfUserSubscriptionCanBeUpgraded(currentUser)
  const subscriptionIsMaximum = checkIfUserSubscriptionIsMaximum(currentUser)

  const isLoggedIn = !!currentUser
  const isPremium = isLoggedIn && !subscriptionIsFree

  const STRINGS = getText('ProfileMenu')

  const handleOpenPaymentModal = () => {
    trackPixelEvent('TryPlatinumClick')
    modalsConfig.setPricingOpen(true)
    modalsConfig.setPricingTrialScreenShown(subscriptionIsFree)
    setSidebarOpen(false)
  }

  if (!isLoggedIn) return null
  if (isPremium && !showAlways) return null
  return (
    <div className={styles.footerProfileMenuHeader}>
      <div className={styles.tryProBtn} onClick={handleOpenPaymentModal}>
        <DiskIcon />

        <span>
          {subscriptionIsFree && STRINGS.startFreeTrial}
          {subscriptionCanBeUpgraded && STRINGS.upgradePlan}
          {subscriptionIsMaximum && STRINGS.myPlan}
        </span>
      </div>
    </div>
  )
}

export default TryProButton
